import { render } from "./BlogBudgetFriendlyGiftsView.vue?vue&type=template&id=1ff4ddf5"
import script from "./BlogBudgetFriendlyGiftsView.vue?vue&type=script&lang=js"
export * from "./BlogBudgetFriendlyGiftsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__